export default "__VITE_ASSET__0b534b81__"